<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">RATING ENGINE / CALCULATORS</h1>
      <button
        type="button"
        class="btn btn-primary"
        @click="$router.push('/addcalculator')"
        id="but"
      >
        Add Calculator
      </button>
    </div>
    <table class="table" style="table-layout: fixed;">
      <thead>
        <tr>
          <th scope="col">Calculator Name</th>
          <th scope="col">Insurer Name</th>
          <th scope="col">Quote Endpoint</th>
          <th scope="col">Parameters Endpoint</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="calculator in calculators"
          :key="calculator.calculator_id"
          @click="edit(calculator.calculator_id)"
          class="clickable-row"
        >
          <td
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
          >
            {{ calculator.calculator_name }}
          </td>
          <td
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
          >
            {{ calculator.insurer_name }}
          </td>
          <td
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
          >
            {{ calculator.api_route }}
          </td>
          <td
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
          >
            {{ calculator.params_route }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      calculators: [],
    };
  },
  methods: {
    async getInsurerName() {
      for (var i = 0; i < this.calculators.length; i++) {
        var calculator = this.calculators[i];
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_id: calculator.insurer_id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/get_single_insurer",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        calculator["insurer_name"] = data["insurer_name"];
      }
    },
    edit(id) {
      this.$router.push("/editcalculator/" + id);
    },
  },
  async mounted() {
    const res = await fetch(config.baseURL + "/get_calculators", {
      credentials: "include",
    });
    const data = await res.json();
    this.calculators = data;
    this.getInsurerName();
    console.log(this.calculators);
  },
};
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}
</style>
